import * as React from 'react';
// ConceptVideoBox
// QuizEditAdmin

//Components
import ConceptDocumentEdit from '../Components/ConceptDocumentEdit';
import autobind from 'autobind-decorator';
import { Container, Card } from 'react-bootstrap';
import ConceptVideoBox from 'Screens/Video/Instructor/Components/ConceptVideoBox';

// This variable is used in multiple modules
const QuestionModuleEditId = "concept-learning-element-quiz";


interface IProps {
    data: any;
    refresh: any;
    concept: any;
}

export default class LearningElementEdit extends React.Component<IProps, {}> {

    @autobind
    public editDocument() {

        this.props.refresh();
    }

    public render() {

        if (!this.props.data) {
            return <div />;
        }

        let elementNode = null;
        if (this.props.data.type === 'video') {
            elementNode = <ConceptVideoBox refresh = {this.props.refresh} concept={this.props.concept} data={this.props.data}/>;

        } else if (this.props.data.type === 'quiz') {
            let questionModuleEditId = QuestionModuleEditId + this.props.data.content.id;
            elementNode = (
                <div>
                    <div id='quiz-edit-admin'>
                        {/* <QuizEditAdmin
                            key={this.props.data.content.id}
                            quiz={this.props.data.content}
                            editQuizTitleCallback={this.editQuizTitle}
                            concept={this.props.concept}
                            refreshConcept={this.props.refresh}
                        /> */}
                        QuizEditAdmin
                    </div>
                    <div id={questionModuleEditId} />
                </div>
            );
        } else if (this.props.data.type === 'document') {
            elementNode = <ConceptDocumentEdit data={this.props.data} saveCallback={this.editDocument} />;
        }

        return (
            <Card >
                <Card.Body>
                    {elementNode}
                </Card.Body>
            </Card>
        );
    }
}
